export const SEVERITY_DEGRADED_THRESHOLD = 4102;
export const SEVERITY_NORMAL_THRESHOLD = 3165;
